import { Pipe, PipeTransform } from '@angular/core';
import { filterList } from '../../helpers';

@Pipe({
    name: 'filterlist',
    standalone: false
})
export class FilterlistPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        return filterList(value, args)
    }
}


